'use client'
import dynamic from 'next/dynamic'
import { useSyncExternalStore } from 'react'

const Sidebar = dynamic(() => import('./Sidebar'))
const ChapterContent = dynamic(() => import('./ChapterContent'))

type DataObject = Record<string, any>
type ChapterPageType = {
  uid: string | undefined
  data: DataObject
  resources: DataObject
  linkType?: string
  locale?: string
}

const PROCESS = ['beginner', 'intermediate', 'advanced']

function getHashFragment(): string {
  return window.location.hash.slice(1)
}

function subscribeToHash(onStoreChange: () => void): () => void {
  window.addEventListener('hashchange', onStoreChange)
  return () => window.removeEventListener('hashchange', onStoreChange)
}

const ChapterPage = ({ uid, data, resources, linkType, locale }: ChapterPageType) => {
  const hash = useSyncExternalStore(subscribeToHash, getHashFragment, () => '')
  const process = PROCESS.includes(hash)

  return (
    <section className="pb-16">
      <div className="container">
        <div className="flex min-h-[700px]">
          <div className="w-[calc(100%-792px)] pr-0 lg:pr-[72px]">
            <Sidebar
              uid={uid as string}
              title={data.data.title}
              resources={resources}
              slug={uid as string}
              linkType={linkType}
              locale={locale}
            />
          </div>
          <div className="w-full lg:w-[792px]">
            <ChapterContent
              uid={uid as string}
              resources={resources}
              data={data}
              process={process}
              linkType={linkType}
              locale={locale}
            />
          </div>
        </div>
      </div>
    </section>
  )
}

export default ChapterPage
